import { compose } from "redux";
import { connect } from "react-redux";
import React, { PureComponent } from "react";
import Delete from "@material-ui/icons/Delete";
import { withStyles } from "@material-ui/core/styles";
import CardTravel from "@material-ui/icons/CardTravel";
import { Grid, Tooltip, IconButton } from "@material-ui/core";

import {
  unloadCardDeployments,
  deleteDeploymentDetail,
} from "features/planner/planner.actions";

import { formatDate } from "utils/format.util";
import { EMPTY_LIST } from "app/app.constants";
import CrudBasePage from "app/components/CrudBasePage";
import { getSummarizedDataStatesFromState } from "app/app.selectors";
import { shiftTypeToString } from "features/planner/planner.mappers";
import { SORT_DIRECTION, ACTIONS } from "features/planner/planner.constants";
import QualificationColumn from "features/planner/employee/travel/QualificationColumn";
import { employeeTravelHistoryOnLoad } from "features/planner/employee/employee.actions";
import { getDeploymentDetailsByCardIdFromState } from "features/planner/planner.selectors";

class EmployeeTravelHistoryContainer extends PureComponent {
  componentDidMount() {
    const { dispatchOnLoad, employeeCardId } = this.props;
    dispatchOnLoad(employeeCardId);
  }

  componentWillUnmount() {
    const { dispatchOnUnload } = this.props;
    dispatchOnUnload();
  }

  columns = [
    {
      xs: true,
      title: "Start date",
      getSortProperty: item => formatDate(item.get("startDate")),
    },
    {
      xs: true,
      title: "End date",
      getSortProperty: item => formatDate(item.get("endDate")),
    },
    {
      xs: true,
      title: "Location",
      getSortProperty: item => item.get("groupName"),
    },
    {
      xs: true,
      component: Grid,
      title: "Qualification",
      getSortProperty: item => (
        <QualificationColumn qualificationId={item.get("qualificationId")} />
      ),
    },
    {
      xs: true,
      title: "Crew",
      getSortProperty: item => item.get("crewName"),
    },
    {
      xs: true,
      title: "Shift",
      getSortProperty: item => shiftTypeToString(item.get("shiftType")),
    },
    {
      xs: true,
      title: "Comment",
      getSortProperty: item => item.get("comment"),
    },
  ];

  actions = [
    {
      getValue: item => (
        <Tooltip title="Delete">
          <IconButton
            onClick={() => this.props.dispatchDeleteDeploymentDetail(item)}
          >
            <Delete fontSize="small" />
          </IconButton>
        </Tooltip>
      ),
    },
  ];

  render() {
    const { Icon, breadcrumb, dataState, deploymentDetails } = this.props;

    return (
      <CrudBasePage
        Icon={Icon}
        title={breadcrumb}
        displaySearchField
        dataState={dataState}
        displayAddButton={false}
        SortableListProps={{
          Icon: CardTravel,
          actions: this.actions,
          columns: this.columns,
          items: deploymentDetails,
          getKey: item => item.get("deploymentDetailId"),
          defaultSortDirection: SORT_DIRECTION.DESC,
          defaultSortColumn: this.columns.findIndex(
            column => column.title === "End date",
          ),
        }}
      />
    );
  }
}

const styles = theme => ({
  root: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(2),
  },
});

EmployeeTravelHistoryContainer.defaultProps = {
  deploymentDetails: EMPTY_LIST,
};

export default compose(
  connect(
    (state, { employeeCardId }) => ({
      deploymentDetails: getDeploymentDetailsByCardIdFromState(
        state,
        employeeCardId,
      ),
      dataState: getSummarizedDataStatesFromState(
        state,
        ACTIONS.GET_CARD_ALL_DEPLOYMENTS,
        ACTIONS.DELETE_DEPLOYMENT_DETAIL,
      ),
    }),
    {
      dispatchOnUnload: unloadCardDeployments,
      dispatchOnLoad: employeeTravelHistoryOnLoad,
      dispatchDeleteDeploymentDetail: deleteDeploymentDetail,
    },
  ),
  withStyles(styles),
)(EmployeeTravelHistoryContainer);
